function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import angular from 'angular';
import { AccesoDatos } from '../../../comun/services/acceso-datos';
import { Preguntas } from '../../../data/Preguntas';
import { Formulario } from '../../../data/formulario';
import { chain } from 'lodash';
import './panel-formular.scss';
var SideBarCtrl = /*#__PURE__*/function () {
  function SideBarCtrl() {
    _classCallCheck(this, SideBarCtrl);
    _defineProperty(this, "$visible", false);
  }
  return _createClass(SideBarCtrl, [{
    key: "toggle",
    value: function toggle() {
      this.$visible = !this.$visible;
    }
  }, {
    key: "open",
    value: function open() {
      this.$visible = true;
    }
  }]);
}();
var PanelFormularComponentCtrl = /*#__PURE__*/function () {
  PanelFormularComponentCtrl.$inject = ["$log", "$timeout", "NotifService", "AccesoDatos"];
  function PanelFormularComponentCtrl($log, $timeout, NotifService, AccesoDatos) {
    _classCallCheck(this, PanelFormularComponentCtrl);
    _defineProperty(this, "panelpregs", {
      bloque: null,
      panel: new SideBarCtrl()
    });
    this.$log = $log;
    this.$timeout = $timeout;
    this.NotifService = NotifService;
    this.AccesoDatos = AccesoDatos;
  }
  return _createClass(PanelFormularComponentCtrl, [{
    key: "goform",
    value: function goform(idform) {
      var _this = this;
      setTimeout(function () {
        var _el = document.getElementById('form_a_' + idform);
        if (_el) _el.scrollIntoView();else _this.goform(idform);
      }, 100);
    }
  }, {
    key: "$onInit",
    value: function $onInit() {
      var _this2 = this;
      this.$log.info('[PanelFormularComponentCtrl] onInit');
      if (this.idform) this.goform(this.idform);
      this.AccesoDatos.EdicionFormular_CLIENT.listaFormularios().then(function (response) {
        _this2.list = chain(response.list).map(function (f) {
          return new Formulario(f);
        }).value();
        _this2.preguntas = new Preguntas(response.preguntas);
      });
    }
  }, {
    key: "nuevoFormulario",
    value: function nuevoFormulario() {
      var _this3 = this;
      var _nuevo = {};
      _nuevo.data = {};
      this.AccesoDatos.EdicionFormular_CLIENT.nuevoFormulario(_nuevo).then(function (response) {
        _this3.list.push(new Formulario(response, true));
        _scrollBottom();
      });
    }
  }, {
    key: "abrirPanelPreguntas",
    value: function abrirPanelPreguntas(form, bloque) {
      this.$log.info('Nueva pregunta para form ', form, bloque);
      this.panelpregs.bloque = bloque;
      this.panelpregs.panel.open();
    }
  }, {
    key: "nuevoFormDuplicado",
    value: function nuevoFormDuplicado(form) {
      this.list.push(new Formulario(form, true));
      _scrollBottom();
    }
  }]);
}();
angular.module('candidato').component('panelFormular', {
  bindings: {
    idform: '<'
  },
  controller: PanelFormularComponentCtrl,
  template: require('./panel-formular.component.html')
  //templateUrl: "../../../../app/ui/vs/prog/dev/templates/panel-formular/panel-formular.component.html"
});
function _scrollBottom() {
  // scroll bottom
  var a = $('.container-fluid');
  if (a && a.length) {
    var _el = a[0];
    setTimeout(function () {
      return _el.scroll({
        behavior: 'smooth',
        top: _el.scrollHeight + 10000
      });
    }, 30);
  }
}